import { motion } from 'framer-motion';

const FadeIn = ({ children, delay = 0, direction = 'up' }) => {
  const directions = {
    up: { y: 12 },
    down: { y: -12 },
    left: { x: 12 },
    right: { x: -12 }
  };

  return (
    <motion.div
      initial={{ 
        opacity: 0, 
        ...directions[direction]
      }}
      whileInView={{ 
        opacity: 1, 
        y: 0,
        x: 0
      }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ 
        duration: 0.28, 
        delay, 
        ease: [0.2, 0.8, 0.2, 1] 
      }}
    >
      {children}
    </motion.div>
  );
};

export default FadeIn;
